module.exports = __webpack_public_path__ + "img/edit.850241e7.svg";